import { render } from "./Grafmonumenten.vue?vue&type=template&id=e294b038&scoped=true"
import script from "./Grafmonumenten.vue?vue&type=script&lang=js"
export * from "./Grafmonumenten.vue?vue&type=script&lang=js"

import "./Grafmonumenten.vue?vue&type=style&index=0&id=e294b038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e294b038"]])

export default __exports__